import { MapPin } from "lucide-react";
import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

// Page affichée à la place du site public quand le mode maintenance est actif (réglable dans Admin > Paramètres).
export default function MaintenancePage() {
  const { t } = useLanguage();
  return (
    <main data-testid="maintenance-page" className="flex min-h-screen flex-col items-center justify-center bg-[#F8FAFC] px-4 text-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="flex h-16 w-16 items-center justify-center rounded-3xl bg-gradient-to-br from-[#2563EB] to-[#06B6D4] shadow-[0_12px_32px_rgba(37,99,235,0.3)]"
      >
        <MapPin className="h-8 w-8 text-white" />
      </motion.div>
      <motion.h1
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55, delay: 0.12, ease: "easeOut" }}
        className="mt-7 max-w-md text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl"
      >
        {t("GoSpot est temporairement en maintenance")}
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55, delay: 0.24, ease: "easeOut" }}
        className="mt-3 max-w-sm text-sm text-slate-500 sm:text-base"
      >
        {t("Nous améliorons la plateforme. Revenez bientôt.")}
      </motion.p>
    </main>
  );
}
